import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { updatePackageStatus } from "../api/services";

export default function AllotModal(props) {
  const [, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const update = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await updatePackageStatus(props.data.id, 2);
      toast.success("Амжилттай");
      props.setShow(false);
      setSearchParams("");
      window.location.reload();
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className="alert alert-success" role="alert">
          <h4 className="alert-heading">Олголт хийх</h4>
          <hr />
          <p className="mb-0">
            <a href="#" className="alert-link me-1">{props?.data?.code}</a>
            дугаартай дайврыг олголт хийх үү?
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.setShow(false)} className="btn btn-light border">
          <span>Хаах</span>
        </Button>
        <Button onClick={update} className="btn btn-success" disabled={loading}>
          {loading ? <i className="mdi mdi-dots-circle mdi-spin" /> : <span>Олгох</span>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
